module.exports = __webpack_public_path__ + "static/img/single_good5.e10ded8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/single_good5.png
// module id = NUfu
// module chunks = 1